(() => {
    Metro.i18n.add("de", {
        weekStart: 1,

        january: "Januar",
        february: "Februar",
        march: "März",
        april: "April",
        may: "Mai",
        june: "Juni",
        july: "Juli",
        august: "August",
        september: "September",
        october: "Oktober",
        november: "November",
        december: "Dezember",

        january_short: "Jan",
        february_short: "Feb",
        march_short: "Mär",
        april_short: "Apr",
        may_short: "Mai",
        june_short: "Jun",
        july_short: "Jul",
        august_short: "Aug",
        september_short: "Sep",
        october_short: "Okt",
        november_short: "Nov",
        december_short: "Dez",

        sunday: "Sonntag",
        monday: "Montag",
        tuesday: "Dienstag",
        wednesday: "Mittwoch",
        thursday: "Donnerstag",
        friday: "Freitag",
        saturday: "Samstag",

        sunday_short: "So",
        monday_short: "Mo",
        tuesday_short: "Di",
        wednesday_short: "Mi",
        thursday_short: "Do",
        friday_short: "Fr",
        saturday_short: "Sa",

        sunday_short_2: "S",
        monday_short_2: "M",
        tuesday_short_2: "D",
        wednesday_short_2: "M",
        thursday_short_2: "D",
        friday_short_2: "F",
        saturday_short_2: "S",

        label_ok: "OK",
        label_cancel: "Abbrechen",
        label_done: "Fertig",
        label_today: "Heute",
        label_now: "Jetzt",
        label_clear: "Löschen",
        label_help: "Hilfe",
        label_yes: "Ja",
        label_no: "Nein",
        label_random: "Zufällig",
        label_save: "Speichern",
        label_reset: "Zurücksetzen",
        label_submit: "Absenden",
        label_add_user_color: "Zu den Farben hinzufügen",
        label_send: "Senden",
        label_accept: "Akzeptieren",
        label_cookies_title: "Diese Seite verwendet Cookies",
        label_cookies_text:
            "Diese Website verwendet Cookies, um sicherzustellen, dass Sie die beste Erfahrung auf unserer Website machen.",
        label_choose_file: "Datei(en) auswählen",
        label_drop_file: "Klicken oder Datei(en) hier ablegen",
        label_files_selected: "{n} Datei(en) ausgewählt",

        label_days: "Tage",
        label_hours: "Stunden",
        label_minutes: "Min",
        label_seconds: "Sek",
        label_month: "Monat",
        label_months: "Monate",
        label_day: "Tag",
        label_year: "Jahr",
        label_years: "Jahre",

        label_rows_count: "Anzeigen:",
        label_search: "Suchen:",
        label_table_info: "Zeige $1 bis $2 von $3 Einträgen",
        label_prev: "Zurück",
        label_next: "Weiter",
        label_all: "Alle",
        label_inspector: "Inspektor",
        label_goto_page: "Gehe zu",
        label_enter_page: "Seite eingeben...",
        label_empty: "Nichts zu zeigen",
        label_user_colors: "Benutzerfarben",
        label_tiles: "Kacheln",
        label_list: "Liste",
        label_load_more: "Mehr laden",
        label_buy: "Kaufen",
        label_buy_now: "Jetzt kaufen",
        label_buy_today: "Heute kaufen",
        label_download: "Herunterladen",
        label_search_results: "Suchergebnisse",
        label_add: "Hinzufügen",
        label_edit: "Bearbeiten",
        label_delete: "Löschen",
        label_new: "Neu",
        label_sell: "Verkaufen",
        label_details: "Details",
        label_sorting: "Sortierung",
        label_finish: "Beenden",
        label_play: "Abspielen",
        label_pause: "Pause",
        label_stop: "Stopp",
        label_mute: "Stummschalten",
        label_loop: "Wiederholen",

        label_on: "an",
        label_off: "aus",

        label_rename_tab: "Tab umbenennen",
        label_close_tab: "Tab schließen",
        label_close_other_tabs: "Andere Tabs schließen",
        label_close_tabs_left: "Tabs links schließen",
        label_close_tabs_right: "Tabs rechts schließen",
        label_close_all_tabs: "Alle Tabs schließen",
        label_close_inactive_tabs: "Inaktive Tabs schließen",

        label_clear_input: "Eingabe löschen",
        label_reveal_password: "Passwort anzeigen",
        label_hide_password: "Passwort verbergen",
        label_generate_random: "Zufälligen Wert generieren",
        label_search_input: "Nach eingegebenem Wert suchen",

        label_note: "Notiz",
        label_tip: "Tipp",
        label_info: "Info",
        label_warning: "Warnung",
        label_question: "Frage",
        label_error: "Fehler",
        label_success: "Erfolg",
        label_caution: "Vorsicht",
        label_alert: "Alarm",
        label_bug: "Fehler",
        label_fuck: "Mist",
        label_important: "Wichtig",
        label_shit: "Scheiße",
        label_air: "Luft",

        label_select_all: "Alles auswählen",
        label_select_more: "Mehr auswählen...",
        label_select: "Auswählen",
        label_filter: "Filter",

        label_collapse: "Einklappen",
        label_attach: "Befestigen",
    });
})();
